<template>
    <div :class="'item' + (topicObj.gestur ? ' gestur' : '')">
        <h1>{{ topicObj.name }}
            <span v-if="topicObj.gestur"> – Gestur: <strong>{{topicObj.gestur}}</strong></span>
        </h1>

        <star-rating inline :text-class="'mystar'" :show-rating="true" @rating-selected="selectRating" :increment="0.5" :read-only="hasRated" :rating="currentSelectedRating"/>

        <div v-if="!hasRated" style="margin-top:10px;">
            <button class="save__btn" v-on:click="saveRating">
                Gefa <strong>{{ name }}</strong> {{ currentSelectedRating }}
                <span v-if="currentSelectedRating > 0.5 && currentSelectedRating < 2">stjörnu</span>
                <span v-else>stjörnur</span>
            </button>
            <div v-if="currentSelectedRating > 0" style="margin-top:10px;">
                <button class="clear__btn" v-on:click="clearRating">Hreinsa</button>
            </div>
        </div>
        <div v-else style="margin-top:10px;">
            <div v-if="currentSelectedRating" style="margin-top:10px;">
                Þú gafst umræðuefninu "{{ name }}" {{ currentSelectedRating }}
                <span v-if="currentSelectedRating > 0.5 && currentSelectedRating < 2">stjörnu</span>
                <span v-else>stjörnur</span>
            </div>
            <div v-if="avarage" style="margin-top:10px;">
                Meðaleinkunn {{ avarage }} stjörnur
            </div>
            <div v-if="count" style="margin-top:10px;">
                {{ count }} hafa kosið
            </div>
        </div>

    </div>
</template>

<script>
    import {db} from '../main'
    import StarRating from 'vue-star-rating'

    export default {
        name: 'Topic',
        components: {StarRating},
        data() {
            return {
                name: this.topicObj.name,
                topic: this.topicObj.slug,
                count: this.topicObj.count,
                avarage: +(this.topicObj.avarage).toPrecision(3),
                currentSelectedRating: localStorage.getItem(this.topicObj.slug + '-rating') ? Number(localStorage.getItem(this.topicObj.slug + '-rating')) : 0,
                episodeNr: this.$route.params.episode_nr,
                hasRated: localStorage.getItem(this.topicObj.slug + '-hasRated') === 'true' || false,
            }
        },
        methods: {
            saveRating: function () {
                this.addRating(this.episodeNr, this.topic, this.currentSelectedRating);
                localStorage.setItem(this.topicObj.slug + '-hasRated', 'true');
                localStorage.setItem(this.topicObj.slug + '-rating', `${this.currentSelectedRating}`);
            },
            selectRating: function (rating) {
                this.currentSelectedRating = rating;
            },
            clearRating: function () {
                this.currentSelectedRating = 0;
            },
            addRating: function (episodeNr, topic, rating) {
                return this.persistRating(db.collection('topics').doc(topic), episodeNr, rating)
            },
            persistRating: function (topic, episodeNr, rating) {
                // In a transaction, add the new rating and update the aggregate totals
                return db.runTransaction(transaction => {
                    return transaction.get(topic).then(res => {
                        if (!res.exists) {
                            throw new Error('Document does not exist!');
                        }
                        // Compute new number of ratings
                        const newCount = res.data().count + 1;
                        // Compute new average rating
                        const oldRatingTotal = res.data().avarage * res.data().count;
                        const newAvarage = +((oldRatingTotal + rating) / newCount).toPrecision(3);
                        // Commit to Firestore
                        transaction.update(topic, {
                            count: newCount,
                            avarage: newAvarage,
                            episode_nr: episodeNr
                        });

                        this.hasRated = true;
                        this.avarage = newAvarage;
                        this.count = newCount;
                    })
                });
            }
        },
        props: ['topicObj']
    }
</script>

<style scoped>
    h1 {
        font-weight: normal;
        margin: 0 0 0.5em 0;
    }

    .item {
        /*text-align: left;*/
        border: 1px solid lightgray;
        padding: 15px 10px;
        margin-bottom: 10px;
        border-radius: 15px;
    }

    .item.gestur{
        background-color: #7b6c3d;
    }

    .save__btn {
        background: lightgray;
        color: #222;
        border: none;
        position: relative;
        height: 40px;
        font-size: 1.1em;
        padding: 0 2em;
        cursor: pointer;
        transition: 600ms ease all;
        outline: none;
    }

    .clear__btn {
        background: lightgray;
        color: #222;
        border: none;
        position: relative;
        height: 20px;
        font-size: 1.0em;
        padding: 0 2em;
        cursor: pointer;
        transition: 600ms ease all;
        outline: none;
    }

    .save__btn:hover,
    .clear__btn:hover {
        background: #a79551;
        color: white;
    }

    .save__btn:before,
    .save__btn:after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        height: 2px;
        width: 0;
        background: lightgray;
        transition: 400ms ease all;
    }

    .save__btn:after {
        right: inherit;
        top: inherit;
        left: 0;
        bottom: 0;
    }

    .save__btn:hover:before,
    .save__btn:hover:after {
        width: 100%;
        transition: 800ms ease all;
    }

</style>

<style>
    .mystar{
        width: 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/Topic.vue